import { keyMirror } from 'ramda-extension';

export const codelistCacheKeys = keyMirror({
	SINGLE_CODELIST: null,
	SINGLE_CODELIST_RAW: null,
});
